import SEOMeta from '@/components/feature/SEOMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于我们 - 爱情岛论坛导航',
  description: '爱情岛论坛导航是一个第三方导航聚合网站，致力于为用户提供最全面、最及时的爱情岛论坛入口导航服务。',
  url: 'https://aiqingdao-navigation.com/about',
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '爱情岛论坛导航',
  url: 'https://aiqingdao-navigation.com/',
  description: '最全的爱情岛论坛入口聚合导航站',
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: '首页', item: 'https://aiqingdao-navigation.com/' },
    { '@type': 'ListItem', position: 2, name: '关于我们' },
  ],
};

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <SEOMeta
        title="关于我们 - 爱情岛论坛导航"
        description="爱情岛论坛导航是一个第三方导航聚合网站，致力于为用户提供最全面、最及时的爱情岛论坛入口导航服务。了解我们的品牌故事、用户口碑和联系方式。"
        keywords="关于我们,爱情岛导航,品牌介绍,联系我们"
        canonicalUrl="https://aiqingdao-navigation.com/about"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />

      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="container-custom">
            <Breadcrumb items={[{ label: '首页', path: '/' }, { label: '关于我们' }]} />
            <div className="pb-8">
              <h1 className="font-heading text-2xl md:text-3xl text-foreground-900">
                关于我们
              </h1>
              <p className="text-sm text-foreground-600 mt-2">
                了解爱情岛论坛导航的品牌故事与使命
              </p>
            </div>
          </div>
        </div>

        <section className="container-custom py-12">
          <div className="max-w-3xl mx-auto">
            <div className="mb-16">
              <h2 className="font-heading text-xl text-foreground-900 mb-4 flex items-center gap-3">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className="ri-building-2-line text-base"></i>
                </span>
                品牌介绍
              </h2>
              <div className="bg-background-100 rounded-lg border border-background-200/70 p-6 space-y-4">
                <p className="text-sm text-foreground-700 leading-relaxed">
                  <strong>爱情岛论坛导航</strong>是一个第三方导航聚合网站，致力于为广大爱情岛论坛用户提供最全面、最及时的入口导航服务。我们深知，在复杂的网络环境下，找到一个稳定可用的论坛访问地址并不容易。正因如此，我们创建了这个导航平台——帮助每一位用户快速定位官方地址和备用线路，让访问论坛变得简单而可靠。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  自上线以来，我们持续收录和更新爱情岛论坛的各类入口链接，覆盖官方主站、镜像站点、CDN加速节点、不同运营商优化线路以及移动端专属入口。我们的目标是——<strong>您只需要收藏本站一个书签，就能随时畅享爱情岛论坛的精彩内容，真正做到"永不迷路"。</strong>
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  我们团队由一群热爱社区文化的互联网从业者组成，秉持"用户至上、信息准确、更新及时"的原则，确保每一条收录的链接都经过严格的人工验证。同时，我们也持续关注用户反馈，不断优化导航体验，让查找入口变得更加高效和愉悦。
                </p>
              </div>
            </div>

            <div className="mb-16">
              <h2 className="font-heading text-xl text-foreground-900 mb-4 flex items-center gap-3">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                  <i className="ri-star-line text-base"></i>
                </span>
                用户口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {[
                  {
                    name: '张先生',
                    role: '论坛资深用户 · 使用3年',
                    text: '自从收藏了这个导航站，再也不用担心找不到论坛入口了。链接更新很快，每次地址变了这里都能第一时间同步。强烈推荐给所有论坛用户！',
                  },
                  {
                    name: '李女士',
                    role: '社区版主',
                    text: '作为版主，我经常需要访问论坛处理版务。这个导航站帮了我大忙，多条备用线路确保了我随时都能登录管理后台。',
                  },
                  {
                    name: '王同学',
                    role: '大学生 · 新用户',
                    text: '刚接触爱情岛论坛时总是找不到正确的地址，偶然发现了这个导航站，真的太方便了！界面简洁，分类清晰，一键直达。',
                  },
                  {
                    name: '赵先生',
                    role: 'IT从业者',
                    text: '从技术角度看，这个导航站的线路覆盖很全面。不同运营商的优化线路都有收录，访问速度和稳定性都让人满意。',
                  },
                  {
                    name: '陈女士',
                    role: '自由职业者',
                    text: '移动端入口非常实用，我经常在外面用手机访问论坛，通过这里的链接可以直接跳转到移动版，体验很流畅。',
                  },
                  {
                    name: '周先生',
                    role: '海外用户',
                    text: '作为海外用户，访问国内论坛有时会遇到困难。这个导航站提供的海外专线备选方案解决了我长期以来的访问难题。',
                  },
                ].map((review, idx) => (
                  <div
                    key={idx}
                    className="bg-background-100 rounded-lg border border-background-200/70 p-5"
                  >
                    <div className="flex items-center gap-1 mb-3">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-sm text-primary-500"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                      "{review.text}"
                    </p>
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center">
                        <span className="text-sm font-medium text-secondary-700">
                          {review.name[0]}
                        </span>
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-900">{review.name}</div>
                        <div className="text-xs text-foreground-500">{review.role}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h2 className="font-heading text-xl text-foreground-900 mb-4 flex items-center gap-3">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                  <i className="ri-mail-line text-base"></i>
                </span>
                联系我们
              </h2>
              <div className="bg-background-100 rounded-lg border border-background-200/70 p-6">
                <p className="text-sm text-foreground-700 leading-relaxed mb-6">
                  如果您发现了新的可用入口链接，或在使用过程中遇到任何问题，欢迎通过以下方式与我们取得联系。我们会在收到反馈后尽快核实和处理。
                </p>
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100">
                      <i className="ri-mail-line text-lg text-primary-600"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-900">电子邮箱</div>
                      <div className="text-sm text-foreground-600">contact@aiqingdao-navigation.com</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100">
                      <i className="ri-links-line text-lg text-accent-600"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-900">反馈建议</div>
                      <div className="text-sm text-foreground-600">如发现链接失效或有新的入口地址，欢迎随时来信反馈</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100">
                      <i className="ri-time-line text-lg text-secondary-600"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-900">响应时间</div>
                      <div className="text-sm text-foreground-600">我们通常在工作日 24 小时内回复您的来信</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-16 p-6 rounded-lg bg-primary-100/70 border border-primary-200/50">
              <div className="flex flex-col sm:flex-row items-center gap-4 text-center sm:text-left">
                <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-500">
                  <i className="ri-heart-line text-xl text-background-50"></i>
                </div>
                <div className="flex-1">
                  <h3 className="font-heading text-base text-foreground-900 mb-1">
                    感谢您的信任与支持
                  </h3>
                  <p className="text-sm text-foreground-600">
                    爱情岛论坛导航将持续优化服务，为您提供更全面、更及时的入口导航。收藏本页，永不迷路。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}